//
// Pipelining function for DataTables. To be used to the `ajax` option of DataTables
// Originally from https://datatables.net/examples/server_side/pipeline.html
//
$.fn.dataTable.pipeline = function ( opts ) {
    // Configuration options
    var conf = $.extend( {
        pages: 5,     // number of pages to cache
        url: '',      // script url
        data: null,   // function or object with parameters to send to the server
                      // matching how `ajax.data` works in DataTables
        method: 'GET', // Ajax HTTP method
        success: null, // callback on ajax success before table is drawn
    }, opts );
 
    // Private variables for storing the cache
    var cacheLower = -1;
    var cacheUpper = null;
    var cacheLastRequest = null;
    var cacheLastJson = null;
 
    return function ( request, drawCallback, settings ) {
        // HACK alert: when using a pipeline cache for ajax data, "All Data" means "a lot of data", but not
        // really "all data".  In this case, a single page of length 32767.
        var ajax          = false;
        var requestStart  = request.start;
        var drawStart     = request.start;
        var requestLength = request.length==-1?32767:request.length;
        var requestEnd    = requestStart + requestLength;
        var confPages     = request.length==-1?1:conf.pages;
         
        if ( settings.clearCache ) {
            // API requested that the cache be cleared
            ajax = true;
            settings.clearCache = false;
        }
        else if ( cacheLower < 0 || requestStart < cacheLower || requestEnd > cacheUpper ) {
            // outside cached data - need to make a request
            ajax = true;
        }
        else if ( JSON.stringify( request.order )   !== JSON.stringify( cacheLastRequest.order ) ||
                  JSON.stringify( request.columns ) !== JSON.stringify( cacheLastRequest.columns ) ||
                  JSON.stringify( request.search )  !== JSON.stringify( cacheLastRequest.search )
        ) {
            // properties changed (ordering, columns, searching)
            ajax = true;
        }
         
        // Store the request for checking next time around
        cacheLastRequest = $.extend( true, {}, request );
 
        if ( ajax ) {
            // Need data from the server
            // this block seems unnecessary for pagination changes.
            if ( requestStart < cacheLower && (requestStart % requestLength) > 0) {
                requestStart = requestStart - (requestLength*(confPages-1)); 
 
                if ( requestStart < 0 ) {
                    requestStart = 0;
                }
            }

            // Paging_Workaround: Because many of the data producers request data as a single monolithic "page" (because page number
            // equals (int)(rowStart/rowsPerPage) and the result consists of the entirity of confPages*requestLength), requests must be 
            // aligned to those boundries where rowsPerPage is an exact divisor of rowStart.
            // eg: if you're on drawStart 1900 of a 10000 row data set size with cache size = 1000 rows (10 pages, 100 rows per page), then
            // in order to stay aligned on 1000-row boundaries, the data request will use requestStart=1000 and requestLength=1000.
            // This means no floating cache pages - some cache results will be optimized towards data "behind" where drawStart is set.
            requestStart -= requestStart % (requestLength * confPages);
             
            cacheLower = requestStart;
            cacheUpper = requestStart + (requestLength * confPages);
 
            // Keep the initial request separate from the request passed to data provider ajax call
            var dataProviderRequest = $.extend(true, {}, request);
            dataProviderRequest.start = requestStart;
            dataProviderRequest.length = requestLength * confPages;
 
            // Provide the same `data` options as DataTables.
            if ( $.isFunction ( conf.data ) ) {
                // As a function it is executed with the data object as an arg
                // for manipulation. If an object is returned, it is used as the
                // data object to submit
                var d = conf.data( dataProviderRequest );
                if ( d ) {
                    $.extend( dataProviderRequest, d );
                }
            }
            else if ( $.isPlainObject( conf.data ) ) {
                // As an object, the data given extends the default
                $.extend( dataProviderRequest, conf.data );
            }
 
            return $.ajax( {
                "type":     conf.method,
                "url":      conf.url,
                "data":     dataProviderRequest,
                "dataType": "json",
                "cache":    false,
                "success":  function ( json ) {
                    if (typeof conf.success==='function') {
                      json = conf.success(json);
                    }

                    cacheLastJson = $.extend(true, {}, json);
 
                    if ( cacheLower != drawStart ) {
                        json.data.splice( 0, drawStart-cacheLower );
                    }
                    if ( requestLength >= -1 ) {
                        json.data.splice( requestLength, json.data.length );
                    }
                     
                    drawCallback( json );
                }
            } );
        }
        else {
            json = $.extend( true, {}, cacheLastJson );
            json.draw = request.draw; // Update the echo for each response
            json.data.splice( 0, request.start-cacheLower );
            json.data.splice( requestLength, json.data.length );
 
            drawCallback(json);
        }
    }
};

// Register an API method that will empty the pipelined data, forcing an Ajax
// fetch on the next draw (i.e. `table.clearPipeline().draw()`)
$.fn.dataTable.Api.register( 'clearPipeline()', function () {
    return this.iterator( 'table', function ( settings ) {
        settings.clearCache = true;
    } );
} );